import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import { clsx } from "clsx";
import { useEditorContext } from "../context.js";
import { useHeaderEditor } from "../header-editor.js";
/* empty css                      */
/* empty css                */
/* empty css                  */
const HeaderEditor = (t0) => {
  const $ = c(13);
  let hookArgs;
  let isHidden;
  if ($[0] !== t0) {
    ({
      isHidden,
      ...hookArgs
    } = t0);
    $[0] = t0;
    $[1] = hookArgs;
    $[2] = isHidden;
  } else {
    hookArgs = $[1];
    isHidden = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      nonNull: true,
      caller: HeaderEditor
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    headerEditor
  } = useEditorContext(t1);
  const ref = useHeaderEditor(hookArgs, HeaderEditor);
  let t2;
  let t3;
  if ($[4] !== headerEditor || $[5] !== isHidden) {
    t2 = () => {
      if (!isHidden) {
        headerEditor == null ? void 0 : headerEditor.refresh();
      }
    };
    t3 = [headerEditor, isHidden];
    $[4] = headerEditor;
    $[5] = isHidden;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  const t4 = isHidden && "hidden";
  let t5;
  if ($[8] !== t4) {
    t5 = clsx("graphiql-editor", t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== ref || $[11] !== t5) {
    t6 = /* @__PURE__ */ jsx("div", { className: t5, ref });
    $[10] = ref;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export {
  HeaderEditor
};
//# sourceMappingURL=header-editor.js.map
